<template>
  <v-app :style="{ backgroundColor: 'black' }">
    <v-main>
      <v-app-bar color="#0d0d0d" dense dark>
        <v-toolbar-title>Hall of Fame</v-toolbar-title>
      </v-app-bar>
      <v-tabs v-model="tab" grow>
        <v-tabs-slider id="slider"></v-tabs-slider>
        <v-tab>Pages</v-tab>
        <v-tab>Groups</v-tab>
        <v-tab-item>
          <v-container fluid>
            <template fluid v-if="loadingPages">
              <hall-of-fame-card v-for="i in 10" :key="i">
                <template v-slot:content>
                  <v-skeleton-loader
                    height="65px"
                    elevation="1"
                    type="list-item-avatar"
                    loading
                  />
                </template>
              </hall-of-fame-card>
            </template>
            <template fluid v-else>
              <hall-of-fame-card
                v-for="(page, i) in pages"
                :key="i"
              >
                <template v-slot:content>
                  <hall-of-fame-header
                    :title="page.name"
                    :imageUrl="page.image_url || page.logo_url"
                    :url="page.hall_of_fame_url"
                    :showSubtitle="false"
                  />
                </template>
              </hall-of-fame-card>
              <hall-of-fame-card v-if="!finishedLoadingPages">
                <template v-slot:content>
                  <v-skeleton-loader
                    v-intersect="pagesIntersect"
                    type="list-item-avatar"
                    loading
                  />
                </template>
              </hall-of-fame-card>
            </template>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid v-if="loadingGroups">
            <hall-of-fame-card v-for="i in 10" :key="i">
              <template v-slot:content>
                <v-skeleton-loader
                  type="list-item-avatar"
                  loading
                />
              </template>
            </hall-of-fame-card>
          </v-container>
          <v-container fluid v-else>
            <hall-of-fame-card
              v-for="(group, i) in groups"
              :key="i"
            >
              <template v-slot:content>
                <hall-of-fame-header
                  :title="group.name"
                  :imageUrl="group.image_url"
                  :url="group.url"
                  :showSubtitle="true"
                >
                  <template v-slot:subtitle>
                    {{ formatPageNameList(group.pages) }}
                  </template>
                </hall-of-fame-header>
              </template>
            </hall-of-fame-card>
            <hall-of-fame-card v-if="!finishedLoadingGroups">
              <template v-slot:content>
                <v-skeleton-loader
                  v-intersect="groupsIntersect"
                  type="list-item-avatar"
                  loading
                />
              </template>
            </hall-of-fame-card>
          </v-container>
        </v-tab-item>
      </v-tabs>
      <v-btn
        color="primary"
        dark
        fab
        bottom
        right
        fixed
        :disabled="loadingPages"
        @click="overlay = true"
      >
        <v-icon>
          mdi-magnify
        </v-icon>
      </v-btn>
      <v-overlay :value="overlay">
        <v-card light>
          <v-card-text>
            <v-text-field
              v-model="searchText"
              label="Search for a page"
              prepend-icon="mdi-magnify"
              :disabled="loadingPages"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              text
              @click="overlay = false"
            >
              Close
            </v-btn>
            <v-btn
              color="primary"
              text
              @click="pagesInitialLoad()"
            >
              Search
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-overlay>
    </v-main>
  </v-app>
</template>
<script>
import hallOfFameHeader from "./components/hallOfFameHeader.vue";
import hallOfFameCard from "./components/hallOfFameCard.vue";

export default {
  components: { hallOfFameHeader, hallOfFameCard },
  data: () => {
    return {
      tab: null,
      pages: null,
      loadingPages: true,
      finishedLoadingPages: false,
      pagesNextPageUrl: null,
      loadingGroups: true,
      finishedLoadingGroups: false,
      groupsNextPageUrl: null,
      searchText: '',
      overlay: false,
    };
  },
  props: {
    pagesApiUrl: String,
    groupsApiUrl: String,
  },
  created() {
    this.pagesInitialLoad();
    this.groupsInitialLoad();
  },
  methods: {
    pagesInitialLoad() {
      this.loadingPages = true;
      this.finishedLoadingPages = false;
      this.pagesNextPageUrl = null;
      this.pages = null;
      this.overlay = false;
      axios.get(
        '/api/hall-of-fame/pages',
        {
          params: {
            search_text: this.searchText,
          },
        },
      ).then(response => {
        this.pages = response.data.data;
        if (response.data.next_page_url) {
          this.pagesNextPageUrl = response.data.next_page_url;
        } else {
          this.finishedLoadingPages = true;
        }
        this.loadingPages = false;
      });
      this.searchText = '';
    },
    groupsInitialLoad() {
      axios.get('/api/hall-of-fame/groups').then((response) => {
        this.groups = response.data.data;
        if (response.data.next_page_url) {
          this.groupsNextPageUrl = response.data.next_page_url;
        } else {
          this.finishedLoadingGroups = true;
        }
        this.loadingGroups = false;
      });
    },
    pagesLoadMore() {
      axios.get(this.pagesNextPageUrl).then((response) => {
        this.pages = this.pages.concat(response.data.data);
        if (response.data.next_page_url) {
          this.pagesNextPageUrl = response.data.next_page_url;
        } else {
          this.finishedLoadingPages = true;
        }
      });
    },
    groupsLoadMore() {
      axios.get(this.groupsNextPageUrl).then((response) => {
        this.groups = this.groups.concat(response.data.data);
        if (response.data.next_page_url) {
          this.groupsNextPageUrl = response.data.next_page_url;
        } else {
          this.finishedLoadingGroups = true;
        }
      });
    },
    pagesIntersect(entries, observer) {
      if (entries[0].isIntersecting && !this.finishedLoadingPages) {
        this.pagesLoadMore();
      }
    },
    groupsIntersect(entries, observer) {
      if (entries[0].isIntersecting && !this.finishedLoadingGroups) {
        this.groupsLoadMore();
      }
    },
    formatPageNameList(pages) {
      if (pages.length <= 5) {
        return pages.map(p => p.name).join(', ')
      }
      return `${pages.slice(0, 5).map(p => p.name).join(', ')} and ${pages.length - 5} more`
    },
  },
};
</script>
<style>
#content {
  padding: 0 !important;
}
.theme--light.v-tabs-items {
  background-color: #f5f8fa !important;
}
.v-skeleton-loader__list-item-avatar {
  height: 100% !important;
}
</style>
<style scoped>
/* #f5f8fa  */
.tab-column {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.logo {
  height: 75px;
  width: 75px;
  background-color: white;
  border-radius: 500px;
  margin: 15px;
}
</style>
